<template>
  <v-app id="inspire">
    <v-app-bar flat app md6 class="secondary">
      <v-toolbar-title class="ml-12 pl-12">
        <span class="font-weight-bold display-1 white--text">AdjusterMate</span>
      </v-toolbar-title>
    </v-app-bar>

    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12 justify-center mx-auto">
            <v-card-title class="secondary" height="20px">
              <span class="body-2 white--text">Forgot Password</span>
            </v-card-title>
            <div v-if="step == 0">
              <v-form ref="form" v-model="valid" lazy-validation>
                <div class="ml-4 pt-10 mb-n9">Enter The Registered Email</div>
                <br />
                <v-row>
                  <v-col class="mx-auto" cols="12" lg="11" md="10">
                    <v-text-field
                      v-model="email"
                      label="Email"
                      :rules="[rules.required,rules.email]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
              <v-card-actions>
                <v-btn text class="primary--text" @click="goBack">BACK</v-btn>
                <!-- <v-btn class="px-1 primary caption" text @click="goBack">BACK</v-btn> -->

                <v-spacer></v-spacer>

                <v-btn text class="secondary--text" @click="onClickNext()">NEXT</v-btn>
              </v-card-actions>
            </div>
            <div v-if="step == 1">
              <v-form ref="form1" v-model="valid2" lazy-validation>
                <div
                  class="ml-4 pt-10 mb-n9"
                >Enter the Activation Code sent to your registered Email.</div>
                <br />
                <v-row>
                  <v-col class="mx-auto" cols="12" lg="11" md="10">
                    <v-text-field
                      v-model="code"
                      label="Code"
                      :rules="[rules.required,rules.counterNumber]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions class="mt-6 mb-2">
                  <div>
                    <v-btn text class="primary--text" @click="goBack">BACK</v-btn>
                  </div>
                  <v-spacer></v-spacer>
                  <div>
                    <v-btn text class="primary--text" @click="onClickNext1()">NEXT</v-btn>
                  </div>
                </v-card-actions>
              </v-form>
            </div>
            <div v-if="step == 2">
              <v-form ref="form2" v-model="valid1" lazy-validation>
                <v-container fluid>
                  <v-text-field
                    label="New Password"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    :rules="[rules.required,rules.newPasswordRules]"
                    v-model="newPwd"
                  ></v-text-field>

                  <v-text-field
                    v-model="cfmPwd"
                    class="mt-5"
                    @click:append="show2 = !show2"
                    :type="show2 ? 'text' : 'password'"
                    :rules="[rules.required,rules.confirmPasswordRules]"
                    label="Confrom Password"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  ></v-text-field>
                </v-container>
                <v-card-actions class="mt-6 mb-2">
                  <div>
                    <v-btn text class="primary--text" @click="goBack">BACK</v-btn>
                  </div>
                  <v-spacer></v-spacer>
                  <div>
                    <v-btn text class="primary--text" @click="resetPassword()">Submit</v-btn>
                  </div>
                </v-card-actions>
              </v-form>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="alertPositive"
        color="secondary"
        :timeout="timeout"
        bottom="bottom"
      >{{ text }}</v-snackbar>
      <v-snackbar
        v-model="alertNegetive"
        color="primary"
        :timeout="timeout"
        bottom="bottom"
      >{{ text }}</v-snackbar>
    </v-container>
  </v-app>
</template>
<script>
import { Auth } from "aws-amplify";
export default {
  data() {
    return {
      step: 0,
      email: "",
      newPwd: "",
      cfmPwd: "",
      valid: true,
      valid1: true,
      valid2: true,
      alertPositive: false,
      alertNegetive: false,
      text: "",
      show1: false,
      show2: false,
      timeout: 1500,
      code: "",
      rules: {
        required: value => !!value || "Required.",
        counter: value => value.length <= 20 || "Max 20 characters",
        counterNumber: v =>
          (v && this.code.length == 6) || "Invalid code length",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail";
        },
        contactNumber: value => {
          const pattern = /^[0-9][0-9]{7,14}$/;
          return pattern.test(value) || "Only Numeric,Min-7 & Max-15 ";
        },
        codeValidationRules: value => {
          const pattern = /^[0-9][0-9]{4,14}$/;
          return pattern.test(value) || "Only Numeric,Min-5 & Max-15 ";
        },
        newPasswordRules: v => {
          return (
            (v && this.newPwd.length > 7) ||
            "Password cannot be less than 8 characters"
          );
        },
        confirmPasswordRules: v => {
          return (v && this.cfmPwd === this.newPwd) || "Password not matching";
        }
      }
    };
  },
  methods: {
    resetPassword() {
      if (this.$refs.form2.validate()) {
        Auth.forgotPasswordSubmit(this.email, this.code, this.newPwd)
          .then(data => {
            console.log(data);
            var changePassword = 1;
            this.$store.commit("SET_forPasswordStatus", changePassword);
            this.$router.push("/");
          })
          .catch(err => {
            // console.log("err", err);
            this.alertNegetive = true;
            this.text = err.message;
          });
      }
    },
    goBack() {
      this.$router.push("/");
    },
    onClickNext1() {
      this.step++;
      this.$refs.form1.validate().then(success => {
        if (success) {
          this.step++;
        }
      });
    },
    onClickNext() {
      if (this.$refs.form.validate()) {
        // this.step++;
        Auth.forgotPassword(this.email)
          .then(data => {
            console.log(data);
            this.step++;
          })
          .catch(err => console.log(err));
      } else {
        this.alertNegetive = true;
        this.text = "Please Add valid Email";
      }
    }
  },
  props: {
    source: String
  }
};
</script>